import { Button, Icon, Modal } from "@scuf/common";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../../../../common/store/combinedReducer";
import { useNavigate } from "react-router-dom";
import "./vmConsole.scss";
import _ from "lodash";
import { getWMKSDetails } from "../../../store/action";
import { customToast } from "../../../../App";
import config from "../../../../common/authentication/config";
import {
  altKeycodes,
  ctrlKeycodes,
  windowsKeycodes,
} from "../../../../common/utility/keycodeCombination";

export default function VmConsole() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const wmksDetails = useSelector((state: AppState) => {
    return state.reducer.wmksDetails;
  });
  const wmksStatus = useSelector((state: AppState) => {
    return state.reducer.wmksStatus;
  });
  const [sessionReconnectPopup, setReconnect] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [isTabActive, setActiveTab] = useState(false);
  const [wmksVal, setWmks] = useState<any>();
  const [stateVal, setStateVal] = useState("");
  const [intervalID, setIntervalID] = useState(0);
  const [show, setShow] = useState(false);
  const [value, setValue] = useState("ctrl");
  const [isVMWin, setVmWin] = useState(false);

  const WMKS = window.WMKS;

  //const initialSyncDoneRef = useRef<boolean>(false);
  //const syncHandlerRef = useRef<((ke: KeyboardEvent) => void) | null>(null);
  const reconnectIntervalRef = useRef<any>(null);
  const countRef = useRef<number>(0);
  const isReconnectingRef = useRef<boolean>(false);
  const vmIdRef = useRef<string>("");

  let wmks: any;
  let data: any;
  let res: any;
  let timer: any;
  let popupTimer: any;
  let x: any;
  let y: any;
  // let copyDataVal: any;

  useEffect(() => {
    if (
      !localStorage.getItem("logged_user") ||
      localStorage.getItem("logged_user") === JSON.stringify(false)
    ) {
      localStorage.setItem("logged_out_from", "vmconsole /");

      navigate("/");
    }
    const lastPart = window.location.pathname?.split("/").pop();
    res = lastPart?.replace(/%20/g, " ");
    document.title = res;
    localStorage.setItem("activeTab", res);
    const val: any = localStorage.getItem(res);
    data = JSON.parse(val);
    data?.isVmWindow !== undefined && setVmWin(data?.isVmWindow);
    vmIdRef.current = data?.id || "";
    const openedTabs = Number(localStorage.getItem("openedTabs") || "0");
    localStorage.setItem("openedTabs", (openedTabs + 1).toString());
    if (data && data?.wmksData?.host) {
      handleVmWareConnection();
    }
    // Notify other tabs that this tab/component has mounted
    localStorage.setItem(
      "vmTabMounted",
      JSON.stringify({ tabName: document.title, timestamp: Date.now() }),
    );
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);
    window.addEventListener("storage", (e: any) => {
      if (e && e.key == "logged_user") {
        localStorage.removeItem(res);
        handleTabClose();
        window.close();
      }
    });

    // Remove tab count when closed
    const handleTabClose = () => {
      const openedTabsStr = localStorage.getItem("openedTabs");
      let openedTabs = openedTabsStr ? Number(openedTabsStr) : 1;
      openedTabs = Math.max(openedTabs - 1, 0);
      localStorage.setItem("openedTabs", openedTabs.toString());
      localStorage.removeItem(res);
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
      handleTabClose(); // Ensure count is updated if component unmounts
    };
  }, []);
  const handleFocus = () => {
    localStorage.setItem("activeTab", document.title);
    setActiveTab(true);
    clearTimeout(timer);
  };

  const handleBlur = () => {
    timer = setTimeout(() => {
      if (localStorage.getItem("activeTab") == document.title) {
        setReconnect(true);
      }
    }, config.INTERVAL); // 2 hours
    setActiveTab(false);
  };
  const refreshToken = () => {
    clearInterval(intervalID);
    setClicked(true);
    setReconnect(false);
  };

  const reconnectVM = () => {
    const lastPart = window.location.pathname?.split("/").pop();
    res = lastPart?.replace(/%20/g, " ");
    const val: any = localStorage.getItem(res);
    data = JSON.parse(val);

    if (
      data?.id !== "" &&
      localStorage.getItem("activeTab") === res &&
      countRef.current <= 3 &&
      navigator.onLine
    ) {
      setStateVal("Reconnecting");
      countRef.current++;
      isReconnectingRef.current = true;
      dispatch(
        getWMKSDetails({
          id: data?.id,
          accessToken: localStorage.getItem("access_token"),
          siteId: data?.siteId,
          tenantId: data?.tenantId,
          orgId: data?.orgId,
          orgName: data?.orgName,
        }),
      );
    } else if (countRef.current > 3) {
      setStateVal("Disconnected.Please relaunch the VM.");
      if (reconnectIntervalRef.current) {
        clearInterval(reconnectIntervalRef.current);
        reconnectIntervalRef.current = null;
      }
    }
  };
  // close window if user does not respond to popup till 30sec
  useEffect(() => {
    if (isTabActive === false && clicked === false) {
      if (sessionReconnectPopup === true) {
        popupTimer = setTimeout(() => {
          // if (clicked === false)
          setReconnect(false);
          localStorage.setItem("logged_out_from", "VM Console");
          navigate("/logout");
        }, 60 * 1000);
        setIntervalID(popupTimer);
      }
    }
  }, [sessionReconnectPopup, isTabActive]);

  useEffect(() => {
    data?.isVmWindow !== undefined && setVmWin(data?.isVmWindow);
  }, [isVMWin, data]);

  // get data and connect to wmks
  useEffect(() => {
    if (wmksStatus === 200 && isReconnectingRef.current) {
      // Only handle reconnect responses meant for this VM
      isReconnectingRef.current = false;
      const lastPart = window.location.pathname?.split("/").pop();
      res = lastPart?.replace(/%20/g, " ");
      const val: any = localStorage.getItem(res);
      data = JSON.parse(val);
      data.isVmWindow !== undefined && setVmWin(data.isVmWindow);
      // Update localStorage with fresh ticket from Redux
      if (wmksDetails.host && wmksDetails.ticket) {
        data.wmksData = wmksDetails;
        localStorage.setItem(res, JSON.stringify(data));
      }
      if (data && data.wmksData && data.wmksData.host) {
        handleVmWareConnection();
      }
    } else if (wmksStatus !== 200 && wmksStatus !== 0) {
      // setLoading(false);
      // setStateVal("disconnected");
      if (
        wmksStatus === 409
        // (wmksDetails && wmksDetails.minorErrorCode) === "VIM_INVALID_STATE"
      )
        customToast(wmksDetails.message, "critical");
      // else if (
      //   wmksStatus === 409 &&
      //   wmksDetails &&
      //   wmksDetails.minorErrorCode === "INVALID_STATE"
      // )
      //   customToast(
      //     `You cannot view the console since VM ${document.title} is not powered on. To view the console first refresh and power on the virtual machine`,
      //     "critical"
      //   );
      else if (wmksStatus === 500)
        customToast(
          "Error in connection. Please try after sometime",
          "critical",
        );
      else if (wmksStatus === 401 || wmksStatus === 403)
        customToast("Unauthorized to access the vm.", "critical");
      // setTimeout(() => {
      //   // close tab and remove the data after few sec to see the popup.
      //   localStorage.removeItem(res);
      //   wmksVal?.sendKeyCodes([WMKS.VSCAN_CODES.VSCAN_L],[WMKS.VSCAN_CODES.VSCAN_RGUI,WMKS.VSCAN_CODES.VSCAN_L]);
      //   window.close();
      // }, 10000)
    }
  }, [wmksDetails, wmksStatus]);

  const tokenPopup = () => {
    return (
      <Modal
        className="userDeleteModal"
        closeIcon={false}
        open={sessionReconnectPopup}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Header className="">You have been idle!</Modal.Header>
        <Modal.Content className="confirmModal">
          <span className="modal-text-vm">You will logged out in 1 minute</span>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="primary"
            size="small"
            content="Stay"
            className="save-secondary"
            onClick={refreshToken}
          />
        </Modal.Footer>
      </Modal>
    );
  };

  const handleVmWareConnection = () => {
    if (data?.wmksData && data?.wmksData?.host) {
      // setLoading(false);
      const host = data?.wmksData.host?.split(":");
      const url = `wss://${host[0]}/${data?.wmksData.port};${data?.wmksData.ticket}`;
      // @ts-ignore
      wmks = WMKS.createWMKS("wmksContainer", {}).register(
        WMKS.CONST.Events.CONNECTION_STATE_CHANGE,
        (event: any, value: any) => {
          //console.log("[WMKS] Connection state:", value.state);
          setStateVal(value.state);
          data?.isVmWindow !== undefined && setVmWin(data?.isVmWindow);
          if (value.state === WMKS.CONST.ConnectionState.CONNECTED) {
            // stateVal = 'Connected';
            $("#mainCanvas").on("focus", function (e: any) {
              wmks?.grab();
              $("#mainCanvas").on("click", function (event: any) {
                setShow(false);
                setValue("");
              });
              $("#mainCanvas").on("mousemove", function (event: any) {
                x = event.clientX + "px";
                y = event.clientY + "px";
              });
              $("#mainCanvas").on("keydown.fullscreen", function (e: any) {
                // check for full screen keydown
                if (wmks.isFullScreen() && data?.isVmWindow) {
                  const floater = document.getElementById("popup-window");
                  if (floater && x && y) {
                    floater.style.left = x;
                    floater.style.top = y;
                  }
                  if (e.originalEvent.keyCode === 17) {
                    // ctrl left button
                    setShow(true);
                    setValue("ctrl");
                  } else if (e.originalEvent.keyCode === 18) {
                    // alt button
                    setShow(true);
                    setValue("alt");
                  } else if (
                    e.originalEvent.keyCode === 91 ||
                    e.originalEvent.keyCode === 92
                  ) {
                    // window button
                    setShow(true);
                    setValue("win");
                  } else {
                    setShow(false);
                  }
                }
              });
            });
            $("#mainCanvas").on("blur", function () {
              wmks?.ungrab();
            });
            clearInterval(reconnectIntervalRef.current);
            reconnectIntervalRef.current = null;
            countRef.current = 0;
            setWmks(wmks);
            handleConnection();
          }
          if (value.state === WMKS.CONST.ConnectionState.DISCONNECTED) {
            // stateVal = 'Disconnected';
            handleDisconnect();
          }
        },
      );
      wmks?.connect(url);
    } else {
    }
  };

  const handleConnection = () => {
    const size = wmksVal?.getRemoteScreenSize();
    wmksVal?.setRemoteScreenSize(size);
    wmksVal?.updateScreen();
    wmksVal?.setOption("changeResolution", true);
    wmksVal?.setOption("rescale", true);
  };
  const handleDisconnect = () => {
    wmksVal?.disconnect();
    if (reconnectIntervalRef.current) {
      clearInterval(reconnectIntervalRef.current);
    }
    reconnectIntervalRef.current = window.setInterval(reconnectVM, 10 * 1000);
  };
  const enterFullScreen = () => {
    const canFullScreen = wmksVal?.canFullScreen();
    // wmksVal?.sendKeyCodes([348], [348]);
    if (canFullScreen) {
      const size = wmksVal?.getRemoteScreenSize();
      wmksVal?.setRemoteScreenSize(size);
      wmksVal?.setOption("changeResolution", true);
      wmksVal?.setOption("rescale", true);
      wmksVal?.enterFullScreen();
      wmksVal?.updateScreen();
      // WMKS?.keyboardUtils.keyDownUpInfo();
    }
  };

  const callCAD = () => {
    wmksVal?.sendCAD();
  };

  const callToggleKeypad = () => {
    WMKS.extendedKeypad.prototype.toggleFunctionKeys();
  };

  const sendKeyValue = (keys: any) => {
    setShow(!show);
    wmksVal?.sendKeyCodes(keys, keys);
  };

  return (
    <>
      {tokenPopup()}
      <>
        <div className="vmware-wrapper" id="wkms">
          <div className="header-vm">
            <div className="header-vm-right">
              <span className="vm-name">
                {document.title !== "Digital Prime Twin" ? document?.title : ""}
              </span>
              {isVMWin === true ? (
                <button
                  id="ctrl-alt-del"
                  className="ctrBtn"
                  data-i18n-key="wmks.ctrl.alt.del"
                  onClick={() => callCAD()}
                >
                  Ctrl+Alt+Del
                </button>
              ) : null}
              {WMKS?.BROWSER.hasTouchInput() ? (
                <button
                  id="keypad"
                  disabled={!WMKS?.BROWSER.hasTouchInput()}
                  className="ctrBtn"
                  onClick={() => callToggleKeypad()}
                >
                  Toggle Keypad
                </button>
              ) : null}
              <span className="vm-name">
                {"Connection Status: " + stateVal}
              </span>
              {stateVal === "disconnected" && countRef.current >= 3 ? (
                <span className="vm-name">
                  {"Please try reconnecting after 2mins"}
                </span>
              ) : null}
            </div>
            <div className="header-vm-left">
              {/* <button
                className="ctrBtn"
                onClick={() => {
                  console.log("[VmConsole] Manual disconnect triggered");
                  setStateVal("disconnected");
                  handleDisconnect();
                }}
              >
                Test Disconnect
              </button> */}
              <Icon
                root="common"
                name="enter-fullscreen"
                size="small"
                className="icon-left vm-fullscreen"
                onClick={() => enterFullScreen()}
              />
            </div>
          </div>
          <div id="wmksContainer" className="vm-wrapper">
            {show && (
              <div id="popup-window">
                {value === "ctrl"
                  ? ctrlKeycodes?.map((key: any, index: any) => {
                      return (
                        <p
                          key={index}
                          onClick={() => sendKeyValue(key.keycode)}
                        >
                          {key.name}
                        </p>
                      );
                    })
                  : value === "alt"
                    ? altKeycodes?.map((key: any, index: any) => {
                        return (
                          <p
                            key={index}
                            onClick={() => sendKeyValue(key.keycode)}
                          >
                            {key.name}
                          </p>
                        );
                      })
                    : value === "win"
                      ? windowsKeycodes?.map((key: any, index: any) => {
                          return (
                            <p
                              key={index}
                              onClick={() => sendKeyValue(key.keycode)}
                            >
                              {key.name}
                            </p>
                          );
                        })
                      : null}
              </div>
            )}
          </div>
        </div>
      </>
    </>
  );
}
